export const initials = (p: {
  first_name?: string | null;
  last_name?: string | null;
}) =>
  `${p.first_name?.[0] ?? ""}${p.last_name?.[0] ?? ""}`.toUpperCase() || "?";
